import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Ai2ProtectedRoute from './components/Ai2/Ai2ProtectedRoute';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import VironNotice from './pages/VironNotice';
import UserList from './pages/UserList';
import GridTest from './pages/GridTest';
import EditAccount from './pages/EditAccount';
import MLMCompanyQualifications from './pages/MLMCompanyQualifications';
import WhySaveClub from './pages/WhySaveClub';
import FAQ from './pages/FAQ';
import EarningsDisclaimers from './pages/EarningsDisclaimers';
import ExpectationsOfViron from './pages/ExpectationsOfViron';
import CorePerspectiveOfViron from './pages/CorePerspectiveOfViron';
import ForgotPassword from './pages/ForgotPassword';
import './App.css';
import Login from './pages/Login';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PaymentLandingPage from './pages/PaymentLandingPage';
import MemberList from './pages/MemberList';
import UserLisetForMember from './pages/UserLisetForMember';
import { ToastContainer } from 'react-toastify'; // ✅ Import here
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './pages/ScrollToTop'; // Import the ScrollToTop component
import AdminEditAccount from './pages/AdminEdit';
import TxcAccountSetup from './pages/TxcAccountSetup';
import DrsPurchase from './pages/DrsPurchase';
import IsVironAScam from './pages/IsVironAScam';
import SaveClub from './pages/SaveClub';

// WEEKLY COMMISSION Route Import - DEMO
import WeeklyCommission from './pages/WeeklyCommission';
import ReferralAndEarningsList from './pages/ReferralAndEarningsList';
import Ai2Backoffice from './pages/Ai2Backoffice';
import Ai2LoginPage from './pages/Ai2Login';
import Ai2CourseSchedule from './pages/Ai2CourseSchedule';
import AffilateProgramVAP from './pages/AffilateProgramVAP';
import ReferralAndEarningsListv1 from './pages/ReferralAndEarningsListv1';
import EmailManagement from './pages/EmailManagement';

function App() {
  const token = localStorage.getItem('token');
  const isAdmin = localStorage.getItem('isAdmin') === '1';


  return (
    <>
      {/* <Router basename="/member"> */}
      <Router>
        <ScrollToTop />
        <ToastContainer position="top-right" autoClose={2000} hideProgressBar closeOnClick />
        <Routes>
          <Route path='Ai2'>
            <Route path='login' element={<Ai2LoginPage />} />
            <Route
              path="forgotPassword"
              element={<ForgotPasswordPage isAi2={true} />}
            />
            <Route
              path='Attendee/Center'
              element={
                <Ai2ProtectedRoute>
                  <Ai2Backoffice />
                </Ai2ProtectedRoute>
              }
            />

            <Route
              path='CourseSchedule'
              element={
                <Ai2ProtectedRoute>
                  <Ai2CourseSchedule />
                </Ai2ProtectedRoute>
              }
            />

          </Route>

          <Route path="member">
            {/* <Route path='/login' element={<Login />} /> */}
            <Route index element={<LoginPage />} />

            <Route path='loginPage' element={<LoginPage />} />
            {/* <Route path="/" element={!isAdmin?<VironNotice />:<UserList/>} /> */}
            {/* <Route path="/home" element={<Home />} /> */}
            <Route
              path='center'
              element={
                <ProtectedRoute>
                  <VironNotice />
                </ProtectedRoute>
              }
            />
            {/* My Referral & Earnings */}
            <Route
              path='referral-and-earings-v1'
              element={
                <ProtectedRoute>
                  <ReferralAndEarningsListv1 />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<div>404 Not Found</div>} />
            {/* My Referral & Earnings */}
            <Route
              path='referral-and-earings'
              element={
                <ProtectedRoute>
                  <ReferralAndEarningsList />
                </ProtectedRoute>
              }
            />

            <Route
              path='affilateprogram'
              element={
                <ProtectedRoute>
                  <AffilateProgramVAP />
                </ProtectedRoute>
              }
            />

            <Route
              path='member-support-edit'
              element={
                <ProtectedRoute>
                  <AdminEditAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path='paymentlandingpage'
              element={<PaymentLandingPage />}
            />
            <Route
              path='admin/userlist'
              element={
                <ProtectedRoute adminOnly={true}>
                  <UserList />
                </ProtectedRoute>
              }
            />
            <Route
              path='admin/memberlist'
              element={
                <ProtectedRoute adminOnly={true}>
                  <MemberList />
                </ProtectedRoute>
              }
            />

            {/* WEEKLY COMMISSION ROUTE - DEMO */}
            <Route
              path='admin/weeklycommission'
              element={
                <ProtectedRoute adminOnly={true}>
                  <WeeklyCommission />
                </ProtectedRoute>
              }
            />
            <Route
              path='admin/emailmanagement'
              element={
                <ProtectedRoute adminOnly={true}>
                  <EmailManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path='admin/adminedit'
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminEditAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path='userlist'
              element={
                <ProtectedRoute adminOnly={true}>
                  <UserLisetForMember />
                </ProtectedRoute>
              }
            />
            <Route
              path='edit-account'
              element={
                <ProtectedRoute>
                  <EditAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path="mlm-qualifications"
              element={
                <ProtectedRoute>
                  <MLMCompanyQualifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="why-TEXITcoin-TXC"
              element={
                <ProtectedRoute>
                  <WhySaveClub />
                </ProtectedRoute>
              }
            />
            <Route
              path="PAYMENT"

            >
              <Route index element={<Navigate to="TXC-ACCOUNT-Setup" replace />} />
              <Route path="TXC-ACCOUNT-Setup" element={<TxcAccountSetup />} />
            </Route>
            <Route
              path='DRs-Purchase'
              element={
                <ProtectedRoute>
                  <DrsPurchase />
                </ProtectedRoute>
              }
            />
            <Route
              path='Save-Club'
              element={
                <ProtectedRoute>
                  <SaveClub />
                </ProtectedRoute>
              }
            />
            <Route
              path="faq"
              element={
                <ProtectedRoute>
                  <FAQ />
                </ProtectedRoute>
              }
            />
            <Route
              path="earnings-disclaimers"
              element={
                <ProtectedRoute>
                  <EarningsDisclaimers />
                </ProtectedRoute>
              }
            />
            <Route
              path="expectations-of-viron"
              element={
                <ProtectedRoute>
                  <ExpectationsOfViron />
                </ProtectedRoute>
              }
            />
            <Route
              path="core-perspective-of-viron"
              element={
                <CorePerspectiveOfViron>
                  <ExpectationsOfViron />
                </CorePerspectiveOfViron>
              }
            />
            {/* <Route
          path="/forgot-password"
          element={
            <ForgotPassword>
              <ExpectationsOfViron />
            </ForgotPassword>
          }
        /> */}
            <Route
              path="forgotPassword"
              element={
                <ForgotPasswordPage>
                  <ExpectationsOfViron />
                </ForgotPasswordPage>
              }
            />
            <Route
              path="reset-password"
              element={<ResetPasswordPage />}
            />
            {/* <Route path="Article">
              <Route
                path="is-VIRON-a-scam"
                element={
                  <ProtectedRoute>
                    <IsVironAScam />
                  </ProtectedRoute>
                }
              />
            </Route> */}
          </Route>
          {/* <Route path="Article">
            <Route
              path="is-VIRON-a-scam"
              element={
                <ProtectedRoute>
                  <IsVironAScam />
                </ProtectedRoute>
              }
            />
          </Route> */}
        </Routes>
      </Router>
    </>
  );
}

export default App;